export const LOCAL_STORAGE_INVISIBLE_EMAILS_KEY = "invisibledEmailIds";

export const LOCAL_STORAGE_READ_EMAILS_KEY = "readEmails";

export const LOCAL_STORAGE_EMAIL_SEARCH_CONDITIONS_KEY =
  "emailSearchConditions";

/**
 * 配信詳細「反応の内訳」アコーディオン 3 本の開閉状態。
 * 設計書 `docs/design-docs/deliveries/open-click-analytics.md` 9.1 /
 * `open-click-analytics.html` 図1。
 */
export const LOCAL_STORAGE_REACTION_BREAKDOWN_KEY = "reactionBreakdownOpen";
